// React
import React from "react";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const ResourceProvider = ({ children }) => {
  // Framework
  const { resource } = usePortal();
  // Init
  useStackDependency(resource);
  // Render
  return <>{children}</>;
};

export { ResourceProvider };
